import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft } from 'lucide-react';
import { useTheme } from '../ThemeContext';
import './Auth.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const { theme } = useTheme();

  const logoUrl = theme === 'light' 
    ? 'https://storage.googleapis.com/msgsndr/oNgjqmOcyIwtcMEEfqUj/media/69051e7ade8283bc1015dd30.webp'
    : 'https://storage.googleapis.com/msgsndr/oNgjqmOcyIwtcMEEfqUj/media/69051e7a306550caec6c2c16.webp';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!email) {
      setError('Please enter your email');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('https://api.eventpiclive.com/api/admin/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to send reset link');
      }

      setSuccess(true);

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="login-page">
        <div className="login-card">
          <div className="login-header">
            <img 
              src={logoUrl} 
              alt="EventPic Live" 
              className="login-logo"
            />
            <h1>Check Your Email</h1>
            <p className="login-subtitle">Reset link sent to your inbox</p>
          </div>

          <div className="card">
            <div className="card-body">
              <p>If an account exists with that email, we've sent a password reset link to your email inbox.</p>
              <p>The link will expire in 1 hour. Don't forget to check your spam folder!</p>
            </div>
          </div>

          <div className="login-footer">
            <Link to="/" className="btn-back">
              <ArrowLeft size={18} />
              Back to Login
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <img 
            src={logoUrl} 
            alt="EventPic Live" 
            className="login-logo"
          />
          <h1>Forgot Password?</h1>
          <p className="login-subtitle">Enter your email to reset your password</p>
        </div>

        {error && (
          <div className="error-banner">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label className="form-label" htmlFor="email">
              <Mail size={18} />
              Email
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              disabled={loading}
              required
              className="form-input"
            />
          </div>

          <button 
            type="submit" 
            className="btn-primary login-submit"
            disabled={loading}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className="login-footer">
          <Link to="/" className="btn-back">
            <ArrowLeft size={18} />
            Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
